module.exports = __webpack_public_path__ + "img/consent_active.0c64bcb3.svg";